<template>
  <div class="container">
    <div class="content">
      <div class="nav">
        <div class="wrapper">
          <span
            class="item"
            v-for="(item,index) in navList"
            :key="index"
            :class="{'item_active':item.select}"
            @click="tabChange(index,item)"
          >{{item.type}}</span>
        </div>
      </div>
    </div>
    <div class="fiedBox"></div>
    <div class="notice_cont">
      <div v-if="!showCont" class="unpublic">
        <div class="notice_list">
          <div class="notice_item" v-for="item in unpublishList" :key="item.id">
            <div class="notice_tit" @click="editNotice(item)" v-if=" updateAuth ==='OPERATION02' ">
              <p class="pad_bottom">{{item.noticeTitle}}</p>
              <!-- <p>综合监管考核评价通报</p> -->
            </div>
            <div class="notice_btn">
              <img src="@/assets/appraise/delete.png" alt  v-if="deleteAuth === 'OPERATION03'" />
              <span class="delete_btn" @click="deleteNotice(item)" v-if="deleteAuth === 'OPERATION03'">删除</span>
              <img src="@/assets/appraise/Group@2x.png" alt   v-if=" sendAuth === 'OPERATION07'" />
              <span @click="publicNotice(item)" v-if=" sendAuth === 'OPERATION07'">发布</span>
            </div>
          </div>
        </div>
        <div v-if="unpublishList.length==0" class="no_data">
          <div class="no_data_img">
            <img src="@/assets/appraise/ic_wuxingxi@2x.png" alt />
          </div>
          <div class="no_data_tip">
            <p>暂无数据</p>
          </div>
        </div>
      </div>
      <div v-if="showCont" class="public">
        <div class="notice_list">
          <div class="notice_item" v-for="item in publishList" :key="item.id">
            <div class="notice_tit" @click="goDetail(item)">
              <p class="pad_bottom" >{{item.noticeTitle}}</p>
              <!-- <p class="pad_bottom" :class="{'read': item.readStatus === 1}">{{item.noticeTitle}}</p> -->
              <!-- <p>综合监管考核评价通报</p> -->
            </div>
            <div class="notice_time">{{item.createTime}}</div>
          </div>
        </div>
        <div v-if="publishList.length==0" class="no_data">
          <div class="no_data_img">
            <img src="@/assets/appraise/ic_wuxingxi@2x.png" alt />
          </div>
          <div class="no_data_tip">
            <p>暂无数据</p>
          </div>
        </div>
      </div>
      <div v-if="!showCont && addAuth === 'OPERATION01' " class="bot_btn">
        <van-button class="add_btn" size="large" @click="addNotice" type="primary">新增公告</van-button>
      </div>
    </div>
    <titleDialog
      v-if="showDialog"
      :title="dialogTitle"
      :cancelTxt="cancelBtn"
      :confirmTxt="confirmBtn"
      @confirm="confirm"
      @cancel="cancel"
    ></titleDialog> 
    <tipDialog :isShow="showTips" :content="requireCont" @closeModal="showTips=false"></tipDialog>
  </div>
</template>

<script>
import titleDialog from "../components/titleDialog.vue";
import api from "@/service/modules/appraiseNew.js";
import tipDialog from "../travelNegative/components/tipDialog";
import icon from "@/assets/appraise/icon_ts_gx@3x.png";
import commonAPI from "../../../utils/common";
export default {
  components: {
    titleDialog,
    tipDialog
  },
  data() {
    return {
      navList: [
        {
          type: "已发布",
          select: true
        },
        {
          type: "未发布",
          select: false
        }
      ],
      showCont: true, // tab切换
      showDialog: false,
      showTips: false,
      requireCont: "",
      dialogTitle: "",
      cancelBtn: "",
      confirmBtn: "",
      isPublish: '',  // 判断是点击的发布按钮（‘2’）还是删除按钮（‘1’）
      selectedNoticeId: '',
      publishList: [], // 已发布列表
      unpublishList: [], // 未发布列表
      // 权限字段
      addAuth: '',
      deleteAuth: '',
      updateAuth: '',
      sendAuth: '',
    };
  },
  created() {
     const childAuth = commonAPI.getAuthorityList("ASSESS_NOTICE");//消息中心
    const notifyobj = commonAPI.getChileAuthList(childAuth, "MENU1101"); // 通知公告
    console.log('-----通知公告:', notifyobj);
    if(notifyobj){
        const btnList = notifyobj.operationType;
        if( btnList && btnList.length > 0){
           for(let i = 0; i< btnList.length; i++){
               if( btnList[i].value === 'OPERATION01' ){
                  this.addAuth = 'OPERATION01' //新增
               }
               if( btnList[i].value === 'OPERATION02'){
                  this.updateAuth = 'OPERATION02' //编辑
               }
               if( btnList[i].value === 'OPERATION03' ){
                  this.deleteAuth = 'OPERATION03'  // 删除
               }
               if( btnList[i].value === 'OPERATION07'){
                  this.sendAuth = 'OPERATION07'  // 发布公告
               }
           }
        }
    }
    this.queryList();
  },
  methods: {
    // 获取公告列表
    queryList() {
      if(this.$route.query.type==="1") this.tabChange(this.$route.query.type);
      let params = {};
      api.findAllNotice(params).then(res => {
        if (res.ret === 0) {
          this.publishList = res.data.filter(item => {
            item.createTime = item.createTime.slice(5, 16);
            return item.isPublish === 1;
          });
          this.unpublishList = res.data.filter(item => {
            return item.isPublish === 0;
          });
        }
      });
    },
    // tab切换
    tabChange(index) {
      this.navList.map((item, i) => {
        this.$set(this.navList[i], "select", false);
      });
      this.navList[index].select = true;
      this.showCont = index === 0 ? true : false;
    },
    // 编辑公告
    editNotice(item) {
      this.$router.push(`/appraise/addNotice?id=${item.id}`);
    },
    // 查看详情
    goDetail(item) {
      this.$router.push(`/appraise/noticeDetail?id=${item.id}`);
    },
    // 新增公告
    addNotice() {
      this.$router.push("/appraise/addNotice");
    },
    // 发布公告
    publicNotice(item) {
      if (item.noticeTitle === null) {
        this.requireCont = "请输入“通知标题”";
        this.showTips = true;
        return;
      } else if (item.noticeContent === null) {
        this.requireCont = "请输入“公告内容”";
        this.showTips = true;
        return;
      } else if (item.fileResVOS==null||item.fileResVOS.length === 0) {
        this.requireCont = "请上传“相关附件”";
        this.showTips = true;
        return;
      }
      this.selectedNoticeId = item.id;
      this.isPublish = '2';
      this.showDialog = true;
      this.dialogTitle = "是否确定发布公告";
      this.cancelBtn = "取消";
      this.confirmBtn = "发布";
    },
    // 删除公告
    deleteNotice(item) {
      this.selectedNoticeId = item.id;
      this.isPublish = '1';
      this.showDialog = true;
      this.dialogTitle = "是否确定删除公告";
      this.cancelBtn = "取消";
      this.confirmBtn = "删除";
    },
    // 弹窗取消回调
    cancel() {
      this.showDialog = false;
    },
    // 弹窗确认回调
    confirm() {
      if(this.isPublish === '1') {
        this.delNotice();
      } else {
        this.submitNotice();
      }
      this.showDialog = false;
    },
    // 删除通告
    delNotice() {
      let params = {
        id: this.selectedNoticeId
      }
      api.delNotice(params).then(res => {
        if(res.ret === 0) {
          this.$Toast({
            message: '删除成功',
            icon
          })
          this.queryList();
        }
      })
    },
    // 发布通告
    submitNotice()  {
      let params = {
        id: this.selectedNoticeId
      }
      api.submitNotice(params).then(res => {
        if(res.ret === 0) {
          this.$Toast({
            message: '发布成功',
            icon
          })
          this.queryList();
          setTimeout(()=>{
            this.tabChange(0);
          },0)
        }
      })
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  .content {
    width: 100%;
    padding: 10px 14px 0 14px;
    box-sizing: border-box;
    overflow: hidden;
    position: fixed;
    top: 0;
    background-color: rgba(251, 251, 251, 1);
    z-index: 99;
    .nav {
      width: 100%;
      height: 40px;
      .wrapper {
        white-space: normal;
        position: absolute;
        .item {
          display: inline-block;
          padding: 10px;
          // border-bottom: 2px solid @base-color;
          font-size: 14px;
        }
        .item_active {
          border-bottom: 2px solid @base-color;
          padding-bottom: 6px;
          color: @base-color;
          font-weight: 600;
          padding-left: 0;
          padding-right: 0;
          margin: 0 10px;
        }
      }
    }
  }
  .bgWhite {
    background-color: #fff;
  }
  .bgGray {
    background-color: #fbfbfb;
  }
  .fiedBox {
    height: 50px;
    width: 100%;
  }
  .child-view {
    margin-top: 1px;
  }
  .footer {
    position: fixed;
    bottom: 0;
    left: 0;
    height: 50px;
    line-height: 50px;
    margin-top: 50px;
    width: 100%;
    text-align: center;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .notice_list {
    margin: 0 12px;
    width: 351px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.06);
    border-radius: 3px;
    .notice_item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px;
      border-bottom: 1px solid #ededed;
    }
    .notice_item:last-child {
      border-bottom: 0;
    }
    .notice_tit {
      display: -webkit-box;
      width: 179px;
      text-overflow: ellipsis;
      overflow: hidden;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .notice_tit p {
      font-size: 14px;
      line-height: 18px;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
    }
    .pad_bottom {
      // padding-bottom: 8px;
      word-break: break-all;
    }
    .notice_btn {
      font-size: 0;
      img {
        display: inline-block;
        width: 14px;
        height: 14px;
        vertical-align: middle;
      }
      span {
        display: inline-block;
        margin-left: 4px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(54, 179, 116, 1);
        vertical-align: middle;
      }
      .delete_btn {
        margin-right: 16px;
      }
    }
    .notice_time {
      font-size: 14px;
      color: #999;
      font-weight: 400;
    }
  }
  .bot_btn {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 10px 12px;
    width: 100%;
    height: 60px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px -2px 8px 0px rgba(0, 0, 0, 0.03);
  }
  .bot_btn .add_btn {
    width: 351px;
    height: 40px;
    background-color: #36b374;
  }
}
.no_data {
  .no_data_img {
    padding: 72px 0 20px;
    img {
      margin: 0 auto;
      width: 74px;
      height: 62px;
    }
  }
  .no_data_tip {
    line-height: 22px;
    font-size: 14px;
    color: #999;
    text-align: center;
  }
  .add_btn_box {
    padding: 32px 0;
    background-color: transparent;
    text-align: center;
    .add_btns {
      width: 70px;
      height: 30px;
    }
  }
}
.read {
  color: #999 !important;
}
</style>
